(function () {
    'use strict';

    angular.module('app').filter('rrNumber', FilterFactory);

    FilterFactory.$inject = ["textValidators"];
    function FilterFactory(textValidators) {
        return function (rrNumber) {
            if (!textValidators.IsValidReferenceNumber(rrNumber, true))
                return rrNumber;

            const onlyNumbers = getOnlyNumbers(rrNumber);

            const datePart = [onlyNumbers.substring(0, 2), onlyNumbers.substring(2, 4), onlyNumbers.substring(4, 6)].join(".");
            const secondPart = [onlyNumbers.substring(6, 9) /* Birth counter */, onlyNumbers.substring(9, 11) /* Checknumber */].join(".");

            return [datePart, secondPart].join("-");
        };

        function getOnlyNumbers(value) {
            return value.replace(/[\D]/g, '').trim();
        }
    }
})();